import React, { Fragment, useEffect, useState } from 'react'
import Logo from "../../images/logo.png"
import { Link, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import { useDispatch, useSelector } from "react-redux";
import { loginAction, clearErrors, forgotPasswordAction } from "../../../redux/actions/userActions";
import Loader from '../../loader/loader';
import Img1 from "../../images/globe.png";
import { FORGET_PASSWORD_RESET, REGISTER_USER_RESET } from '../../../redux/constants/userConstant';



const Login = () => {

  const dispatch = useDispatch();
  const navigate = useNavigate();


  const { loading, error, message } = useSelector((state) => state.register);
  const { isAuthenticated } = useSelector((state) => state.verifyEmailStore);

  const { loading: forgotLoading,
    error: forgotError,
    message: forgotMessage
  } = useSelector((state) => state.forgotPassword);


  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [showFogotSection, setshowFogotSection] = useState(false)
  const [isSubmit, setIssubmit] = useState(false)
  const [isForgotSubmit, setisForgotSubmit] = useState(false)
  const [showPassword, setShowPassword] = useState(false)


  const handleSubmit = (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }

    if (!password) {
      toast.error("please Enter your Password")
      return
    }
    if (password.length < 8) {
      toast.error("Password should contain atleast 8 digits")
      return
    }

    dispatch(loginAction({ email, password }));

    setIssubmit(true)

  }



  useEffect(() => {
    if (message && isSubmit) {
      toast.success(message);
      localStorage.setItem("email", email);
      navigate('/verify-email');
      setIssubmit(false);
      dispatch({ type: REGISTER_USER_RESET });
    }
    if (error) {
      toast.error(error);
      dispatch(clearErrors());
    }
    if (isAuthenticated) {
      navigate('/')
    }
  }, [error, message, navigate, dispatch, email, isAuthenticated, isSubmit]);








  const handleForgotSubmit = (e) => {
    e.preventDefault()

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      toast.error("Please enter a valid email address");
      return;
    }


    const userData = {
      email: email,
    }

    dispatch(forgotPasswordAction(userData))

    setisForgotSubmit(true)
  }

  useEffect(() => {
    if (forgotError) {
      toast.error(forgotError)
      dispatch(clearErrors())
    }

    if (forgotMessage && isForgotSubmit) {
      toast.success(forgotMessage)
      navigate('/forgot-password')
      localStorage.setItem("email", email);
      dispatch({ type: FORGET_PASSWORD_RESET })
    }

    document.title = `LOGIN`;


  }, [forgotError, dispatch, forgotMessage, navigate, email, isForgotSubmit])




  useEffect(() => {

    document.title = 'LOGIN'

  }, [])


  return (
 // UI ONLY UPDATED - ALL FUNCTIONALITY PRESERVED
// Keep all imports, redux logic, handlers and useEffects exactly as they are.
// Replace only the JSX returned inside Fragment.

<Fragment>
  {loading || forgotLoading ? (
    <Loader />
  ) : (
    <>
      <section
        className="min-h-[100vh] flex items-center justify-center p-[2vmax] login-bg relative overflow-hidden"
      >
        
       
        <div
          className="
            bg-white/95
            backdrop-blur-sm
            rounded-[2vmax]
            w-full
            lg:w-[80%]
            min-h-[42vmax]
            overflow-hidden
            shadow-[0_2vmax_5vmax_rgba(110,97,255,0.12)]
            flex
            flex-col
            md:flex-row
            relative
            z-10
          "
        >
          {/* LEFT SIDE */}
          <div
            className="
              md:w-[48%]
              bg-[#fafaff]
              p-[2.5vmax]
              border-r
              border-[#f1f1f8]
              relative
              flex
              flex-col
            "
          >
            {/* Logo */}
            <div
              className="
                w-fit
              "
            >
              <img
                src={Logo}
                alt="logo"
                className="w-[12vmax]"
              />
            </div>

            {/* Globe */}
            <div className="flex justify-center items-center flex-1 relative">
              {/* Orbit Ring */}
            

             
              <img
                src={Img1}
                alt="globe"
                className="w-[28vmax] object-contain"
              />
            </div>

            {/* Bottom Card */}
            <div
              className="
                bg-white
                rounded-[1.5vmax]
                p-[1.5vmax]
                shadow-[0_1vmax_3vmax_rgba(0,0,0,0.05)]
                flex
                items-center
                gap-[1.2vmax]
              "
            >
              <div
                className="
                  w-[4vmax]
                  h-[4vmax]
                  rounded-[1vmax]
                  bg-gradient-to-br
                  from-violet-400
                  to-violet-600
                  flex
                  items-center
                  justify-center
                  text-white
                  text-[1.8vmax]
                "
              >
                <i className="fa-solid fa-shield-halved"></i>
              </div>

              <div>
                <h4 className="font-bold text-[1.2vmax]">
                  Secure. Smart. Seamless.
                </h4>

                <p className="text-[1vmax] text-gray-500">
                  Your gateway to powerful management and insights.
                </p>
              </div>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div
            className="
              md:w-[52%]
              flex
              items-center
              justify-center
              p-[3vmax]
            "
          >
            <form
              className="w-full max-w-[32vmax]"
              onSubmit={handleSubmit}
            >
              <h2
                className="
                  font-bold
                  text-[2.3vmax]
                  text-[#111827]
                "
              >
                Welcome back
              </h2>

              <p
                className="
                  text-[1.15vmax]
                  text-gray-500
                  mt-[0.4vmax]
                "
              >
                Your Admin Dashboard
              </p>

              {/* EMAIL */}
              <div className="mt-[4vmax]">
                <label className="block text-[1.1vmax] mb-[0.6vmax]">
                  Email Address{" "}
                  <span className="text-red-500">*</span>
                </label>

                <div className="relative">
                  <i
                    className="
                      fa-regular fa-envelope
                      absolute
                      left-[1.2vmax]
                      top-1/2
                      -translate-y-1/2
                      text-violet-500
                      text-[1.2vmax]
                    "
                  ></i>

                  <input
                    type="text"
                    value={email}
                    onChange={(e) =>
                      setEmail(e.target.value)
                    }
                    placeholder="Enter your email"
                    className="
                      w-full
                      pl-[3.5vmax]
                      pr-[1vmax]
                      py-[1vmax]
                      rounded-[0.8vmax]
                      border
                      border-[#dedee8]
                      outline-none
                      focus:border-violet-400
                      text-[1.1vmax]
                    "
                  />
                </div>
              </div>

              {/* PASSWORD */}
              <div className="mt-[1.5vmax]">
                <label className="block text-[1.1vmax] mb-[0.6vmax]">
                  Password{" "}
                  <span className="text-red-500">*</span>
                </label>

                <div className="relative">
                  <i
                    className="
                      fa-solid fa-lock
                      absolute
                      left-[1.2vmax]
                      top-1/2
                      -translate-y-1/2
                      text-violet-500
                      text-[1.2vmax]
                    "
                  ></i>

                  <input
                    type={
                      showPassword
                        ? "text"
                        : "password"
                    }
                    value={password}
                    onChange={(e) =>
                      setPassword(e.target.value)
                    }
                    placeholder="Enter your password"
                    className="
                      w-full
                      pl-[3.5vmax]
                      pr-[4vmax]
                      py-[1vmax]
                      rounded-[0.8vmax]
                      border
                      border-[#dedee8]
                      outline-none
                      focus:border-violet-400
                      text-[1.1vmax]
                    "
                  />

                  <button
                    type="button"
                    onClick={() =>
                      setShowPassword(
                        (prev) => !prev
                      )
                    }
                    className="
                      absolute
                      right-[1.2vmax]
                      top-1/2
                      -translate-y-1/2
                      text-[1.2vmax]
                    "
                  >
                    <i
                      className={`fa-solid ${
                        showPassword
                          ? "fa-eye-slash"
                          : "fa-eye"
                      }`}
                    ></i>
                  </button>
                </div>
              </div>

              {/* FORGOT */}
              <div className="text-right mt-[0.8vmax]">
                <button
                  type="button"
                  onClick={() =>
                    setshowFogotSection(true)
                  }
                  className="
                    text-violet-600
                    text-[1vmax]
                    font-medium
                  "
                >
                  Forgot Password?
                </button>
              </div>

              {/* SIGN IN */}
              <button
                type="submit"
                className="
                  w-full
                  mt-[2vmax]
                  py-[1vmax]
                  rounded-[1vmax]
                  text-white
                  font-bold
                  text-[1.25vmax]
                  bg-gradient-to-r
                  from-violet-600
                  to-violet-400
                  shadow-[0_1vmax_3vmax_rgba(124,58,237,0.35)]
                  flex
                  items-center
                  justify-center
                  gap-[1vmax]
                  transition-all
                  duration-300
                  hover:scale-[0.98]
                "
              >
                Sign In

                <span
                  className="
                    w-[2.2vmax]
                    h-[2.2vmax]
                    rounded-full
                    bg-white/20
                    flex
                    items-center
                    justify-center
                  "
                >
                  <i className="fa-solid fa-arrow-right"></i>
                </span>
              </button>

              {/* SIGNUP */}
              <div
                className="
                  text-center
                  mt-[2vmax]
                  text-[1.1vmax]
                "
              >
                Don't have an account?
                <Link
                  to="/signup"
                  className="
                    ml-[0.3vmax]
                    text-violet-600
                    font-semibold
                  "
                >
                  Sign up
                </Link>
              </div>
            </form>
          </div>
        </div>
      </section>

      {/* FORGOT PASSWORD MODAL */}
      <section
        className="flex-center fixed top-0 left-0 bg-[#000000d7] w-full min-h-screen z-[100]"
        style={{
          display: showFogotSection
            ? "flex"
            : "none",
        }}
      >
        <form
          className="
            bg-white
            rounded-[1.2vmax]
            p-[2vmax]
            w-[90%]
            lg:w-[30%]
          "
          onSubmit={handleForgotSubmit}
        >
          <h4
            className="
              text-center
              font-bold
              text-[1.7vmax]
              text-violet-600
            "
          >
            Forgot Password
          </h4>

          <div className="mt-[1.5vmax]">
            <label className="block text-[1vmax] mb-[0.5vmax]">
              Email Address
            </label>

            <input
              type="text"
              value={email}
              onChange={(e) =>
                setEmail(e.target.value)
              }
              className="
                w-full
                border
                rounded-[0.6vmax]
                px-[1vmax]
                py-[0.8vmax]
                text-[1vmax]
              "
            />
          </div>

          <button
            type="submit"
            className="
              w-full
              mt-[1.5vmax]
              py-[0.8vmax]
              rounded-[0.8vmax]
              text-white
              font-semibold
              bg-gradient-to-r
              from-violet-600
              to-violet-400
            "
          >
            Forgot Password
          </button>
        </form>

        <button
          className="
            fixed
            top-[2vmax]
            right-[2vmax]
            text-white
            text-[2.5vmax]
          "
          onClick={() =>
            setshowFogotSection(false)
          }
        >
          <i className="fa-solid fa-circle-xmark"></i>
        </button>
      </section>
    </>
  )}
</Fragment>

  )
}

export default Login